// Live cursors for Remote Support sessions. Rendered as an absolute overlay
// over the whole canvas (NOT inside the world/zoom layers), with positions
// computed each animation frame from the shared pan/zoom refs:
//   screen = pan + zoom * world
// Everything position-related is imperative (refs + rAF) so 60fps cursor
// traffic never re-renders React; only roster changes re-render the list.

const React = require('react');
const { createElement: h, useRef, useEffect } = React;
require('./RemoteCursorsLayer.css');

function RemoteCursorsLayer(props) {
  var members = Array.isArray(props.members) ? props.members : [];
  var selfSessionId = props.selfSessionId || '';
  var cursorsRef = props.cursorsRef;   // { sessionId: {x, y, username, color} }
  var panPosRef = props.panPosRef;
  var zoomRef = props.zoomRef;
  var elementsRef = useRef({});        // sessionId -> DOM node

  var others = members.filter(function(member) {
    return member && member.sessionId && member.sessionId !== selfSessionId;
  });

  useEffect(function() {
    var frame = null;
    function tick() {
      var cursors = (cursorsRef && cursorsRef.current) || {};
      var pan = (panPosRef && panPosRef.current) || { x: 0, y: 0 };
      var zoom = (zoomRef && zoomRef.current) || 1;
      Object.keys(elementsRef.current).forEach(function(sessionId) {
        var el = elementsRef.current[sessionId];
        var cursor = cursors[sessionId];
        if (!el) return;
        if (!cursor) {
          el.style.opacity = '0';
          return;
        }
        el.style.opacity = '1';
        el.style.transform = 'translate(' +
          (pan.x + cursor.x * zoom) + 'px, ' +
          (pan.y + cursor.y * zoom) + 'px)';
      });
      frame = requestAnimationFrame(tick);
    }
    frame = requestAnimationFrame(tick);
    return function() { if (frame) cancelAnimationFrame(frame); };
  }, []);

  if (!others.length) return null;

  return h('div', { className: 'remote-cursors-layer', 'aria-hidden': 'true' },
    others.map(function(member) {
      return h('div', {
        key: member.sessionId,
        className: 'remote-cursor',
        style: { opacity: 0 },
        ref: function(el) {
          if (el) elementsRef.current[member.sessionId] = el;
          else delete elementsRef.current[member.sessionId];
        }
      },
        h('svg', { className: 'remote-cursor-arrow', width: 18, height: 18, viewBox: '0 0 24 24' },
          h('path', {
            d: 'M4 2l16 8.5-7 1.8L9.5 20 4 2z',
            fill: member.color || '#7c5cff',
            stroke: '#ffffff',
            strokeWidth: 1.4
          })
        ),
        h('span', {
          className: 'remote-cursor-name',
          style: { background: member.color || '#7c5cff' }
        }, member.username || 'Guest')
      );
    })
  );
}

module.exports = RemoteCursorsLayer;
